module.exports = __webpack_public_path__ + "img/zeus_alt1.789b17bb.png";